import React from 'react';

import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import appSettings from 'wanderu-config';

import styles from './CarrierLogo.scss';

const sizeProp = PropTypes.oneOf(['small', 'large']);

function CarrierLogoImg(props) {
    const {
        carrierCode,
        carrierName,
        className = '',
        size = 'small',
        ...otherProps
    } = props;
    const carrierLogos = getCarrierLogoUrls(carrierCode);
    const sizeClass = size === 'small'
        ? styles.carrierLogoSmall
        : styles.carrierLogoLarge;

    return (
        <img
            alt={carrierName}
            className={`${sizeClass} ${className}`}
            src={carrierLogos.small}
            srcSet={`${carrierLogos.small} 1x, ${carrierLogos.large} 2x`}
            title={carrierName}
            {...otherProps}
        />
    );
}

CarrierLogoImg.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: sizeProp,
};

function CarrierLogo(props) {
    const {
        lazyload = true,
        seoLazyload = false,
        ...carrierLogoProps
    } = props;

    if (!seoLazyload && lazyload) {
        return (
            <LazyLoad height={20} once>
                <CarrierLogoImg {...carrierLogoProps} />
            </LazyLoad>
        );
    }

    return (
        <CarrierLogoImg
            {...carrierLogoProps}
            loading={seoLazyload
                ? 'lazy'
                : 'auto'}
        />
    );
}

function getCarrierLogoUrls(carrierCode) { // exists in S3Service in wanderu-service-account but wasn't code splitting. Investigate again.
    return {
        large: `${appSettings.config.s3.staticAssetsUrl}carriers/icons-x2/${carrierCode}.png`,
        small: `${appSettings.config.s3.staticAssetsUrl}carriers/icons/${carrierCode}.png`,
    };
}

CarrierLogo.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string.isRequired,
    className: PropTypes.string,
    lazyload: PropTypes.bool,
    seoLazyload: PropTypes.bool,
    size: sizeProp,
};

export {
    CarrierLogo,
    sizeProp,
};
export default CarrierLogo;
